import "./AlertToasts.css";
import cn from "classnames";
import type { CSSProperties, FC } from "react";
import { useId } from "react";
import { ButtonIcon } from "../../components/ButtonIcon";
import { type Alert, AlertType, useAlertSubscribe } from "./Alert";
import { useExpiringItems } from "./useExpiringItems";

interface ToastStatusStyle extends CSSProperties {
	"--toast-status": number;
}

const title: Record<AlertType, string> = {
	[AlertType.ERROR]: "Error",
	[AlertType.INFO]: "Information",
	[AlertType.SUCCESS]: "Success",
	[AlertType.WARNING]: "Warning",
};

export const AlertToasts = () => {
	const { items, addItem, removeItem, pauseItem, resumeItem } =
		useExpiringItems<Alert>();
	const id = useId();

	useAlertSubscribe((alert) => {
		addItem(alert, { ttl: 5_000 });
	});

	if (items.length === 0) {
		return null;
	}

	return (
		<div className="ntoast-container">
			{items.map((alert, i) => {
				return (
					// biome-ignore lint/a11y/noStaticElementInteractions: pause timer on hover
					<div
						key={`${id}-${alert.id}-${i}`}
						className={cn("ntoast", alert.value.type)}
						onMouseEnter={() => pauseItem(alert.id)}
						onMouseLeave={() => resumeItem(alert.id)}
					>
						<AlertStatus
							value={(alert.remaining ?? alert.ttl ?? 1) / (alert.ttl ?? 1)}
						/>
						<div className="header">
							{title[alert.value.type]}
							<ButtonIcon icon="close" onClick={() => removeItem(alert.id)} />
						</div>
						<div className="body">{alert.value.content}</div>
					</div>
				);
			})}
		</div>
	);
};

const AlertStatus: FC<{ value: number }> = ({ value }) => {
	const style: ToastStatusStyle = {
		"--toast-status": value,
	};
	return <div style={style} className="status" />;
};
